import React, {createContext, useReducer} from "react";


export enum ThemeType {
    Default = "default",
    DefaultFont = "Inter",
}

export enum ThemeActions {
    ChangeTheme,
    ChangeFont
}

export interface IThemeState {
    currentTheme?: string | "" | ThemeType.Default,
    currentFont?: string | "" | ThemeType.DefaultFont
}

export interface IAction {
    type: ThemeActions;
    payload?: IThemeState | null;
}

const INITIAL_STATE: IThemeState = {
    currentTheme: localStorage.getItem("theme") || ThemeType.Default,
    currentFont: localStorage.getItem("font") || ThemeType.DefaultFont,
};

function reducer(state:IThemeState , action: IAction): IThemeState {
    switch (action.type) {
        case ThemeActions.ChangeTheme:
            localStorage.setItem("theme", action.payload?.currentTheme || ThemeType.Default);
            return {
                ...state,
                ...action.payload
            };
        case ThemeActions.ChangeFont:
            localStorage.setItem("font", action.payload?.currentFont || ThemeType.DefaultFont);
            return {
                ...state,
                ...action.payload
            };

        default: return state
    }
}

function useThemeReducer() {
    const [themeState, themeDispatch] = useReducer(reducer, INITIAL_STATE);
    return {
        themeState,
        themeDispatch,
    };
}

export const ThemeContext = createContext(
    {} as ReturnType<typeof useThemeReducer>
);

export const ThemeProvider: React.FunctionComponent = ({ children }) => {
    const { themeState, themeDispatch } = useThemeReducer();
    return (
        <ThemeContext.Provider value={{ themeState, themeDispatch }}>
            {children}
        </ThemeContext.Provider>
    );
};